module.exports = __webpack_public_path__ + "_/assets/images/icons/marker_ps-2ba9f0bad8bcf0d5583580096f1d9c21.png";